module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.getType() === 'v-img') ? _c('v-img', {
    staticClass: "elevation-2",
    attrs: {
      "src": _vm.URL,
      "width": _vm.width,
      "height": _vm.height
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getType() === 'v-img' && _vm.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.URL,
      "label": "Download",
      "noBlock": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getType() === 'cld-image') ? _c('cld-image', {
    attrs: {
      "cloudName": _vm.cldConfig.CLOUD_NAME,
      "public-id": _vm.publicID,
      "width": _vm.width,
      "loading": _vm.trans.loading || ''
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getType() === 'cld-video') ? _c('div', {
    class: _vm.className || ''
  }, [_c('video', {
    staticClass: "cld-video-player cld-fluid",
    attrs: {
      "id": ("cld-player-" + _vm.videoID),
      "data-cld-public-id": _vm.publicID,
      "controls": ""
    }
  }), _vm._v(" "), (_vm.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.URL,
      "label": "Download"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.getType() === 'video') ? _c('div', {
    class: _vm.className || ''
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('video', {
    staticClass: "custom-preview-img",
    attrs: {
      "id": "postVdoMedia",
      "src": _vm.URL,
      "width": _vm.width,
      "height": _vm.height,
      "controls": ""
    }
  }, [_vm._v("             \n          Your browser does not support the video tag.\n      ")]), _vm._v(" "), (_vm.download) ? _c('btn-download', {
    attrs: {
      "url": _vm.URL,
      "label": "Download",
      "noBlock": true
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.getType() === 'iframe') ? _c('iframe', {
    class: _vm.className || '',
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "src": _vm.URL,
      "allow": "autoplay",
      "scrolling": "no",
      "seamless": "",
      "allowFullScreen": ""
    }
  }) : (_vm.getType() === 'driveCustomView') ? _c('gDrive-post-view', {
    attrs: {
      "url": _vm.URL,
      "darkTheme": true
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66123d62"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/custom/CustomMedia.vue
// module id = 2163
// module chunks = 0